import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers"
import Footer from "../ones/Footer"
import MarketplaceSection from "../ones/MarketplaceSection"
import MarketplaceSlider from "../ones/MarketplaceSlider"
import OneBook from "../ones/OneBook"
import OneJournal from "../ones/OneJournal"
import OneStory from "../ones/OneStory"
import OneVideo from "../ones/OneVideo"

export default function HomeLanding() {

  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllBooks(),
      appContext.getAllVideos(),
      appContext.getAllJournals(),
      appContext.getAllStories(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    const books = appContext.allBooks || [];
    const videos = appContext.allVideos || [];
    const journals = appContext.allJournals || [];
    const stories = appContext.allStories || [];

    const recentContent = [
      ...books.map((item) => ({ ...item, type: 'Book' })),
      ...videos.map((item) => ({ ...item, type: 'Video' })),
      ...journals.map((item) => ({ ...item, type: 'Journal' })),
      ...stories.map((item) => ({ ...item, type: 'Story' })),
    ].sort((first, second) => {
      return Number(second.dateCreated) - Number(first.dateCreated);
    }).slice(0, 8);

    return (
      <>
        <MarketplaceSlider items={recentContent} />

        <div className="container marketplace-home-container">
          <div className="marketplace-intro text-center">
            <span className="marketplace-eyebrow text-primary">THE MIKA KENYATA MARKETPLACE</span>
            <h6 className="main-section-title">Discover something meaningful.</h6>
            <p>
              Browse books, videos, journals and stories created to inform, inspire and entertain.
            </p>
          </div>

          <MarketplaceSection
            title="Recent Books"
            items={books.slice(0, 3)}
            itemComponent={OneBook}
            moreItem="books"
            moreLabel="View More Books"
          />

          <MarketplaceSection
            title="Recent Videos"
            items={videos.slice(0, 3)}
            itemComponent={OneVideo}
            moreItem="videos"
            moreLabel="View More Videos"
          />

          <MarketplaceSection
            title="Recent Journals"
            items={journals.slice(0, 3)}
            itemComponent={OneJournal}
            moreItem="journals"
            moreLabel="View More Journals"
          />

          <MarketplaceSection
            title="Recent Stories"
            items={stories.slice(0, 3)}
            itemComponent={OneStory}
            moreItem="stories"
            moreLabel="View More Stories"
          />
        </div>

        <Footer />
      </>
    )
  }

  return <div className="container mSupportLoading">{getInlineLoader()}</div>;
}
